module.exports = __webpack_public_path__ + "static/media/key-sign.33737ab5.svg";